<template>
  <div>
    <memory-info
      class="px-1"
      :show-title="false"
      :capacity="host.memoryCapacity || 0"
    />
    <memory-chart
      class="mt-2"
      :capacity="host.memoryCapacity || 0"
    />
  </div>
</template>
<script>
import MemoryInfo from './info/MemoryInfo.vue'
import MemoryChart from './charts/MemoryChart.vue'

export default {
  name: 'HostDetailsMemory',
  components: { MemoryInfo, MemoryChart },
  props: {
    host: {
      type: Object,
      required: true,
    },
  },
}
</script>
